export class POSTTYPE {
  /**
     * new area
     */
  cus_emailAddress: string;

  in_reseller_accountcode: string;

  in_org_type: string;
  in_customer_name: string;
  in_entity_name: string;
  in_trust_name: string;
  in_ABN: string;
  in_ACN: string;
  //TODO: here need to add a new field
  in_RequestLimitCredit: string;
  in_date_business_started: string;
  in_date_business_purchased: string;
  in_bank_contact: string;
  in_bank_address1: string;
  in_bank_address2: string;
  in_bank_address3: string;
  in_swift_address: string;
  in_bank_account_name: string;
  in_bsb: string;
  in_account_number: string;
  in_incorporation_date: string;
  in_incorporation_place: string;
  in_estimated_monthly_purch: string;
  in_company_address1: string;
  in_company_address2: string;
  in_company_address3: string;
  in_company_street: string;
  in_company_suburb: string;
  in_company_country: string;
  in_company_postcode: string;
  in_parent_company: string;
  in_delivery_address1: string;
  in_delivery_address2: string;
  in_delivery_address3: string;
  in_delivery_street: string;
  in_delivery_suburb: string;
  in_delivery_country: string;
  in_delivery_postcode: string;
  in_tenancy: string;
  in_time_at_address: string;
  in_email: string;
  in_phone: string;
  in_fax: string;
  in_company_website_url: string;
  in_required_credit: string;
  in_online_contact: string;
  in_admin_email: string;
  in_password: string;
  in_part_ship: string;
  in_director1_name: string;
  in_director1_dob: string;
  in_director1_phone: string;
  in_director1_address1: string;
  in_director1_address2: string;
  in_director1_address3: string;
  in_director1_street: string;
  in_director1_suburb: string;
  in_director1_country: string;
  in_director1_postcode: string;
  in_director1_licence_no: string;
  in_director2_name: string;
  in_director2_dob: string;
  in_director2_phone: string;
  in_director2_address1: string;
  in_director2_address2: string;
  in_director2_address3: string;
  in_director2_street: string;
  in_director2_suburb: string;
  in_director2_country: string;
  in_director2_postcode: string;
  in_director2_licence_no: string;
  in_director3_name: string;
  in_director3_dob: string;
  in_director3_phone: string;
  in_director3_address1: string;
  in_director3_address2: string;
  in_director3_address3: string;
  in_director3_street: string;
  in_director3_suburb: string;
  in_director3_country: string;
  in_director3_postcode: string;
  in_director3_licence_no: string;
  in_supplier1_name: string;
  in_supplier1_contact: string;
  in_supplier1_phone: string;
  in_supplier1_email: string;
  in_supplier2_name: string;
  in_supplier2_contact: string;
  in_supplier2_phone: string;
  in_supplier2_email: string;
  in_supplier3_name: string;
  in_supplier3_contact: string;
  in_supplier3_phone: string;
  in_supplier3_email: string;
  in_supplier4_name: string;
  in_supplier4_contact: string;
  in_supplier4_phone: string;
  in_supplier4_email: string;
  in_current_year_turnover: string;
  in_last_year_turnover: string;
  in_current_assets: string;
  in_current_liabilities: string;
  in_capital: string;
  in_no_of_shares: string;
  in_encumberance_charges: string;
  in_bankrupcy: string;
  in_read_and_understood: string;
  in_mailing_list: string;
  in_mailing_email: string;
  in_declare_name: string;
  in_declare_position: string;
  in_declare_path: string;
  in_declare_date: string;
  in_guarantee_cust_name: string;
  in_guarantor_name: string;
  in_guarantor_address1: string;
  in_guarantor_address2: string;
  in_guarantor_address3: string;
  in_guarantor_street: string;
  in_guarantor_suburb: string;
  in_guarantor_country: string;
  in_guarantor_postcode: string;
  in_guarantor_sig_path: string;
  in_guarantor_date: string;
  in_guarantor_abn: string;
  in_witness_name: string;
  in_witness_address1: string;
  in_witness_address2: string;
  in_witness_address3: string;
  in_witness_street: string;
  in_witness_suburb: string;
  in_witness_country: string;
  in_witness_postcode: string;
  in_witness_sig_path: string;
  in_witness_date: string;
  in_doc_path: string;

  /**
   * contacts
   */

  in_manager_name: string;
  in_manager_email: string;
  in_manager_phone: string;
  in_so_manager_name: string;
  in_so_manager_email: string;
  in_so_manager_phone: string;
  in_po_manager_name: string;
  in_po_manager_email: string;
  in_po_manager_phone: string;
  in_ap_manager_name: string;
  in_ap_manager_email: string;
  in_ap_manager_phone: string;
  in_3p_manager_name: string;
  in_3p_manager_email: string;
  in_3p_manager_phone: string;

  /**
     * new market info added
     * TODO: need to change the first 2 elemewnts below to
     * array
     */

  in_principal_products: string;

  // in_other_products
  in_markets: string;
  // in_oth
  in_other_product_desc: string;
  in_other_market_desc: string;


  in_focus_size: string;
  in_percent_annuity_based: string;
}



// WEBPACK FOOTER //
// ./src/app/model/post-type.ts